export const text = {
  initialHeaderName: 'Inkomende koppeling',
  description:
    'Hier kun je extra velden aan de inkomende koppeling toevoegen. Standaard zijn de velden NAWTE en tags beschikbaar.',
  goBackLink: '/-/apps/zapier/events',
  children: null,
};

export const breadcrumbs = [
  {
    to: '/-/apps',
    label: 'Apps',
  },
  { to: '/-/apps/zapier/events', label: 'Zapier' },
];
